String.prototype.nullWhenEmpty = function () {
    return this.length > 0 ? this : null;
}

String.prototype.before = function (separator) {
    return this.split(separator)[0];
}

String.prototype.after = function (separator) {
    return this.split(separator).slice(1).at(0);
}

String.prototype.between = function (start, end) {
    return this.after(start).before(end);
}

Number.prototype.countDecimals = function () {
    if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
    return this.toString().split(".")[1].length || 0;
}

Array.prototype.nullWhenEmpty = function () {
    return this.length > 0 ? this : null;
}